import React, { useEffect, useState } from "react";
import "./style.scss";
import playerImg from "assets/playervideo.png";
import { useLocation, useNavigate } from "react-router-dom";
import { Progress } from "antd";
import { RightOutlined, UserOutlined } from "@ant-design/icons";
// import { ICourse } from "types";
import { api } from "services/api";
import { useSelector } from "react-redux";
import { IProgress } from "types";
import { AddTopicModal, Loading } from "components";
import ReactQuill from "react-quill";
import Swal from "sweetalert2";
import { useForm } from "antd/lib/form/Form";

export const CoursePage: React.FC = () => {
	const [userModules, setUserModules] = useState<any[]>();
	const [courseForumId, setCourseForumId] = useState<string>("");
	const [topicId, setTopicId] = useState<string>("");
	const [topicsInfos, setTopicsInfos] = useState<any>();
	const [value, setValue] = useState<string>("");
	const [forumTopics, setForumTopics] = useState<any[]>();
	const [currentTopic, setCurrentTopic] = useState<any>();
	const [userProgress, setUserProgress] = useState<IProgress>();
	const [loading, setLoading] = useState<boolean>(false);
	const [pageType, setPageType] = useState<string>("module");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [form] = useForm();
	// @ts-ignore
	const { state }: { state: any } = useLocation();
	const { id: userId } = useSelector((state: any) => state.app.user);
	const navigate = useNavigate();
	const courseId = state.id;
	const courseGeneralInfo = state;

	const handleSendMessage = () => {
		api
			.post(`/topics/${topicId}/messages`, {
				id_topico: topicId,
				text: value,
				user_id: userId,
				is_active: true,
			})
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					api.get(`/topics/${topicId}/messages`).then((res) => {
						setTopicsInfos(res.data.data);
					});
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						setValue("");
						form.resetFields();
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		const loadData = async () => {
			if (userId && courseId) {
				setLoading(true);
				await api
					.get(`/courses/${courseId}/users/${userId}/progress`)
					.then(async (res) => {
						setUserProgress(res.data.data);
						console.log(userProgress);
					});

				await api
					.get(`/courses/${courseGeneralInfo.id}/modules/users/${userId}`)
					.then(async (res) => {
						const formattedModules = await Promise.all(
							res.data.data.modules.map(async (module: any) => {
								const {
									data: {
										data: { classes },
									},
								} = await api.get(`modules/${module.id}/publiched-classes`);

								return { ...module, classes };
							})
						);
						await api
							.get(`/forums/${res?.data?.data?.forum?.id}/topics`)
							.then((r) => {
								setForumTopics(r.data.data.topics);
							});

						setCourseForumId(res?.data?.data?.forum?.id);
						setLoading(false);
						setUserModules(formattedModules);
					});
			}
		};

		loadData();

		// eslint-disable-next-line
	}, [courseId, userId]);

	return (
		<div className="course">
			<div className="course__container">
				<div className="course__container__header">
					<div className="course__container__header__first-row">
						<img
							src={state.image ? state.image : playerImg}
							width="350px"
							height={"100%"}
							alt=""
						/>
						<div className="course__container__header__first-row__info">
							<h1 className="course__container__header__first-row__info__title">
								{state.title} 
							</h1>
							<span className="course__container__header__first-row__info__author">
								(Por {state.author})
							</span>
							<p className="course__container__header__first-row__info__description">
								{state.description}
							</p>
							<p className="course__container__header__first-row__info__age">
								Classificação indicativa: {state.age}
							</p>
							{state?.tags && (
								<div className="course__container__header__first-row__info__tags">
									<span>
										Tags:
									</span>

									{Array.isArray(state?.tags) ? (
										state.tags?.map((item: string, index: number) => (
											<span className="tag" key={index}>
												{item}
											</span>
										))
									) : (
										<span className="tag">{state?.tags}</span>
									)}
								</div>
							)}
						</div>
					</div>
					<div className="course__container__header__second-row">
						<div className="course__container__header__second-row__progress">
							{userProgress?.total_class} de{" "}
							{userProgress?.finished_class} aulas concluídas
							<Progress percent={userProgress?.progress} />
						</div>
						<div className="course__container__header__second-row__forum">
							<button
								className="course__container__header__second-row__btn"
								onClick={() =>
									setPageType((prevState) =>
										prevState === "module" ? "forum" : "module"
									)
								}
							>
								{pageType === "module"
									? "Acessar fórum do curso"
									: "Voltar ao conteúdo do curso"}
							</button>
						</div>

					</div>
					<hr />
				</div>
				{pageType === "module" && (
					<div className="course__container__modules">
						<h1 className="course__container__modules__title">Módulos</h1>
						<div className="course__container__modules__items">
							{userModules &&
								userModules.map((module, index) => {
									const { classes, description, title, id } = module;
									return (
										<div
											key={index}
											className="course__container__modules__items__card"
										>
											<div className="course__container__modules__items__card__infos">
												<h1 className="course__container__modules__items__card__infos__title">
													{title}
												</h1>
												<p className="course__container__modules__items__card__infos__description">
													{description}
												</p>
												<div className="course__container__modules__items__card__infos__btns">
													{/* <Progress
													width={20}
													percent={percent}
													style={{ margin: "5px 0 5px 0" }}
													strokeWidth={8}
												/> */}
													<button
														onClick={() => {
															navigate(`/my-courses/${courseId}/module/${id}`, {
																state: {
																	description,
																	// percent,
																	title,
																	classes,
																	id,
																	courseGeneralInfo: {
																		...courseGeneralInfo,
																		modules: userModules,
																		currentModule: {
																			moduleTitle: userModules?.[index]?.title,
																			lessonTitle:
																				userModules?.[index]?.classes[0]?.title,
																			lessonDescription:
																				userModules?.[index]?.classes?.[0]
																					?.description,
																			index: 1,
																			currentClassId:
																				userModules?.[index]?.classes?.[0]?.id,
																		},
																	},
																},
															});
														}}
													>
														Continuar
														<RightOutlined />
													</button>
												</div>
											</div>
										</div>
									);
								})}
							{loading && <Loading title="Módulos" />}
						</div>
					</div>
				)}

				{pageType === "forum" && (
					<div className="class-module">
						<AddTopicModal
							setIsOpen={setIsOpen}
							isOpen={isOpen}
							forumId={courseForumId}
							form={form}
							setForumTopics={setForumTopics}
						/>
						<div className="class-module__container">
							<div
								className="class-module__container__info"
								style={{ height: pageType === "forum" ? "615px" : "" }}
							>
								{pageType === "forum" && (
									<>
										<div className="class-module__container__info__forum-topics__header">
											<h1 className="class-module__container__info__forum-topics__header__title">
												Fórum de dúvidas
											</h1>
											<button
												className="class-module__container__info__forum-topics__header__btn"
												onClick={() => setIsOpen(!isOpen)}
											>
												Criar tópico
											</button>
										</div>
										<div className="class-module__container__info__forum-topics">
											{forumTopics &&
												forumTopics.map((module: any, index: number) => {
													const { id, created_at } = module;
													return (
														<div
															key={index}
															className="class-module__container__info__forum-topics__topic"
															style={{ cursor: "pointer" }}
															onClick={() => {
																setTopicId(id);
																api
																	.get(`/topics/${id}/messages`)
																	.then((res) => {
																		setTopicsInfos(res.data.data);
																	});
																setCurrentTopic(module);
															}}
														>
															<div className="class-module__container__info__forum-topics__topic__img">
																<UserOutlined twoToneColor="#000" />
															</div>
															<div className="info">
																<h1 className="class-module__container__info__forum-topics__topic__title">
																	{module.subject}
																</h1>
																<div
																	style={{
																		display: "flex",
																		flexDirection: "row",
																		justifyContent: "space-between",
																		width: "100%",
																	}}
																>
																	<p>Nome do criador do tópico</p>
																	<p>{created_at}</p>
																</div>
															</div>
														</div>
													);
												})}

											{!forumTopics && (
												<div
													style={{
														height: "100%",
														width: "100%",
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
													}}
												>
													<Loading title="Tópicos" />
												</div>
											)}

											{forumTopics && !forumTopics?.length && (
												<p
													style={{
														height: "100%",
														width: "100%",
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
													}}
												>
													Não há tópicos disponíveis.
												</p>
											)}
										</div>
									</>
								)}
							</div>

							{pageType === "forum" && (
								<div className="class-module__container__forum">
									<div className="class-module__container__forum__topics-container">
										{topicsInfos?.messages && (
											<h1 className="module__container__lesson__module-title">
												Tópico atual: {currentTopic?.subject}
											</h1>
										)}
										{!topicsInfos?.messages && (
											<p
												style={{
													height: "100%",
													width: "100%",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}
											>
												Selecione um tópico para visualizar suas respectivas
												mensagens.
											</p>
										)}
										{topicsInfos?.messages?.length === 0 && (
											<p
												style={{
													height: "100%",
													width: "100%",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
												}}
											>
												Ainda não há mensagens para exibir nesse tópico.
											</p>
										)}
										{topicsInfos?.messages.map(
											(
												{ message, user }: { message: any; user: any },
												index: number
											) => {
												console.log({ user });
												return (
													<div
														key={index}
														className="class-module__container__forum__topics-container__topic"
													>
														<div className="class-module__container__forum__topics-container__topic__img">
															<UserOutlined twoToneColor="#000" />
														</div>
														<div className="info">
															<h1
																style={{
																	textTransform: "capitalize",
																	margin: 0,
																	lineHeight: "12px",
																}}
															>
																{user[0]?.username}
															</h1>
															<p style={{ fontWeight: "100" }}>
																Criado em: {message.created_at}
															</p>
															<div
																dangerouslySetInnerHTML={{
																	__html: `<p>${message.text}</p>`,
																}}
															></div>
														</div>
													</div>
												);
											}
										)}
									</div>

									{topicsInfos?.messages && (
										<>
											<div className="class-module__container__forum__input">
												<ReactQuill
													theme="snow"
													value={value}
													onChange={setValue}
												/>
											</div>
										</>
									)}
									<div className="class-module__container__forum__btns">
										<button style={{ display: "none" }}></button>

										{topicsInfos?.messages && (
											<button onClick={() => handleSendMessage()}>
												Enviar
											</button>
										)}
									</div>
								</div>
							)}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
